module.exports = __webpack_public_path__ + "media/about/max-doyle-cfe0f734.png";